export { redirectToLoginPage } from './authentication.js';
